/**
 * Async entry so non-eager Module Federation shared deps (e.g. react)
 * can initialize before the app imports them. See RUNTIME-006.
 */
import('./bootstrap');
